import { render, staticRenderFns } from "./DetailLayoutTwoColumns.vue?vue&type=template&id=c2e5d706"
import script from "./DetailLayoutTwoColumns.vue?vue&type=script&lang=js"
export * from "./DetailLayoutTwoColumns.vue?vue&type=script&lang=js"
import style0 from "./DetailLayoutTwoColumns.vue?vue&type=style&index=0&id=c2e5d706&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports